import React, { useContext } from "react";
import minLogo from "./Assets/logo-mini.png";
import miniLogo from "./Assets/logo-min-white.png";
import "../Components/Assets/css/newStyle.css";
import { MyContext } from "./Context/SharedStateContext";
import { Link } from "react-router-dom";
import adminIcon from "./Assets/adminIcon.png";
import "./Assets/css/newDesign.css";

const Navbar = () => {
  const { setIsSidebarOpen, setIsSidebarMinimized, userLimit } =
    useContext(MyContext);

  const tenantName = localStorage.getItem("tenantName");
  const isWidgetUser = localStorage.getItem("isWidget") === "true";

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  const toggleMinimizeSidebar = () => {
    setIsSidebarMinimized((prev) => !prev);
  };

  return (
    <nav
      className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row bg-white"
      style={{ position: "sticky", top: "0" }}
    >
      <div
        className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
        style={{ backgroundColor: "#f0f1f6" }}
      >
        <Link className="navbar-brand brand-logo" to="/">
          <img src={miniLogo} alt="logo" />
        </Link>
        <Link className="navbar-brand brand-logo-mini" to="/">
          <img src={minLogo} alt="logo" />
        </Link>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button
          className="navbar-toggler navbar-toggler align-self-center"
          type="button"
          data-toggle="minimize"
          onClick={toggleMinimizeSidebar}
          style={{ fontSize: "25px" }}
        >
          <span className="mdi mdi-menu"></span>
        </button>

        <ul className="navbar-nav-right">
          {/* {userLimit && !isWidgetUser && (
            <li className="nav-item">
              <Link to="/ChatPrice" className="upgrade-btn">
                <i className="mdi mdi-arrow-up-bold-circle"></i>
                <span className="upgrade-text">Upgrade Plan</span>
              </Link>
            </li>
          )} */}

          <li className="nav-profile">
            <div className="profile-dropdown-toggle">
              <div className="profile-avatar">
                <img src={adminIcon} alt="Admin Profile" />
              </div>
              <div className="profile-info">
                <span className="profile-name">{tenantName}</span>
                <span className="profile-role">Admin</span>
              </div>
            </div>
          </li>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          data-toggle="offcanvas"
          onClick={toggleSidebar}
          style={{ fontSize: "28px" }}
        >
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
